if (!customElements.get('mc-purchase-prices')) {
  customElements.define('mc-purchase-prices', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.targets = [...this.info.querySelectorAll('button.mc-atc-button')];
      this.frame = null;
      this.schedule = () => {
        if (!this.isConnected || this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.fit();
        });
      };
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.textSignature = () => this.targets.map(button => button.textContent).join('\u0001');
      this.lastText = this.textSignature();
      this.textObserver = new MutationObserver(() => {
        const text = this.textSignature();
        if (text !== this.lastText) { this.lastText = text; this.schedule(); }
      });
      for (const button of this.targets) {
        this.resizeObserver.observe(button);
        this.textObserver.observe(button, { childList: true, characterData: true, subtree: true });
      }
      window.addEventListener('resize', this.schedule);
      document.fonts?.addEventListener('loadingdone', this.schedule);
      document.fonts?.ready.then(this.schedule);
      this.schedule();
    }

    update(html) {
      const source = html.getElementById(this.info.id);
      if (!source) throw new Error('Missing purchase price section');
      const selectors = ['.mc-pdp-price__current', '.mc-pdp-price__was', '[data-mc-atc-current]', '[data-mc-atc-compare]'];
      const updates = [];
      for (const selector of selectors) {
        const destinations = [...this.info.querySelectorAll(selector)];
        const fragments = [...source.querySelectorAll(selector)];
        if (destinations.length !== fragments.length) throw new Error('Incomplete purchase price section');
        destinations.forEach((node, index) => updates.push({ node, fragment: fragments[index] }));
      }
      let changed = false;
      for (const { node, fragment } of updates) {
        if (node.innerHTML !== fragment.innerHTML) { node.innerHTML = fragment.innerHTML; changed = true; }
        if (fragment.hasAttribute('data-mc-has-compare')) {
          if (node.dataset.mcHasCompare !== fragment.dataset.mcHasCompare) {
            node.dataset.mcHasCompare = fragment.dataset.mcHasCompare;
            node.hidden = fragment.hidden;
            changed = true;
          }
        }
      }
      if (changed) this.schedule();
    }

    fit() {
      for (const button of this.targets) {
        const compare = button.querySelector('[data-mc-atc-compare]');
        if (!compare) continue;
        compare.hidden = compare.dataset.mcHasCompare !== 'true';
        if (compare.hidden || !button.clientWidth) continue;
        const style = getComputedStyle(button);
        const parts = [...button.children].filter(node => !node.classList.contains('loading__spinner') && !node.hidden);
        const required = parts.reduce((sum, node) => sum + node.getBoundingClientRect().width, 0)
          + Math.max(0, parts.length - 1) * (parseFloat(style.columnGap) || 0);
        const available = button.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        compare.hidden = required > available - 1;
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver.disconnect();
      this.textObserver.disconnect();
      window.removeEventListener('resize', this.schedule);
      document.fonts?.removeEventListener('loadingdone', this.schedule);
      this.targets = [];
    }
  });
}
